module.exports = __webpack_public_path__ + "static/fonts/HarmonyOS_Sans_Naskh_Arabic_Regular.2d09dc1b.ttf";